export default __webpack_public_path__ + "static/markets_and_price_discovery-50adf79db8c37c467f14421544895fc9.png";